import React from "react"
import clsx from "clsx"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"

const useStyles = makeStyles((theme) => ({
  root: {
    clear: "both",
    // marginBottom: theme.spacing(5),
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 960,
    padding: theme.spacing(4),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      paddingBottom: theme.spacing(5),
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
      paddingTop: theme.spacing(5),
    },
  },
  rootFullWidth: {
    maxWidth: "100%",
  },
  wrapper: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  wrapperFullWidth: {
    width: "100%",
    maxWidth: 640,
  },
  wrapperTransparent: {
    background: "transparent",
  },
  wrapperWideContent: {
    maxWidth: 960,
  },
}))

export default function FormContainer({
  children,
  fullWidth = false,
  transparent = false,
  wideContent = false,
}) {
  const classes = useStyles()

  return (
    <Paper
      className={clsx(classes.root, {
        [classes.rootFullWidth]: fullWidth,
        [classes.wrapperTransparent]: transparent,
      })}
      elevation={transparent ? 0 : 3}
      square
    >
      <div
        className={clsx(classes.wrapper, {
          [classes.wrapperFullWidth]: fullWidth,
          [classes.wrapperWideContent]: wideContent,
        })}
      >
        {children}
      </div>
    </Paper>
  )
}
